import { render, staticRenderFns } from "./base-config.vue?vue&type=template&id=527fbeef&scoped=true&"
import script from "./base-config.vue?vue&type=script&lang=js&"
export * from "./base-config.vue?vue&type=script&lang=js&"
import style0 from "./base-config.vue?vue&type=style&index=0&id=527fbeef&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527fbeef",
  null
  
)

export default component.exports